import React, { Component } from 'react';
import { Field } from 'formik';

import SingleCheckboxField from 'buyside/components/presentation/Form/Field/SingleCheckboxField/singleCheckboxField';
import InvestmentMandate from 'buyside/components/presentation/JobVaultSubmission/InvestmentMandate/InvestmentMandate';

import styles from './PositionInvestmentMandateStyles.scss';

class PositionInvestmentMandate extends Component {
  render() {
    const { values } = this.props;

    return (
      <div className={styles.container}>
        <Field
          component={SingleCheckboxField}
          name="useCompanyInvestmentMandate"
          type="checkbox"
          label="Same as company investment mandate"
          value={values.useCompanyInvestmentMandate}
          customStyles={styles}
        />

        {!values.useCompanyInvestmentMandate && (
          <div className={styles.positionInvestmentMandate}>
            <InvestmentMandate {...this.props} />{' '}
          </div>
        )}
      </div>
    );
  }
}

export default PositionInvestmentMandate;
